// TourPage.jsx
import React from "react";
import "./TourPage.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper"; 
import "swiper/css";
import "swiper/css/pagination";


const TourPage = ({ 
  title,
  subtitle,
  heroImage,
  intro,
  overview,
  highlights,
  location,
  howToReach,
  thingsToDo,
  facilities,
  bestTime,
  travelTips
}) => {
  return (
    <div className="tourPage">
      {/* ===== Hero Section ===== */}
      <section className="tourHero" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="tourHeroOverlay">
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </div>
      </section>

      <div className="tourContainer">
        <p className="tourIntro">{intro}</p>
        <hr className="tourDivider" />

        {/* ===== Overview ===== */}
{/* ===== Overview ===== */}
{overview && (
  <section className="tourSection">
    <h2>🏝️ Overview</h2>

    {/* Overview List */}
    <ul>
      {overview.list.map((item, idx) => (
        <li key={idx}>{item}</li>
      ))}
    </ul>

    {/* Single Image (optional) */}
    {overview.image && (
      <img src={overview.image}
       alt={title} className="tourImg" />
    )}

    {/* === Image Slider (inside Overview) === */}
    {overview.images && overview.images.length > 0 && (
      <Swiper
        modules={[Pagination]}
        pagination={{ clickable: true }}
        spaceBetween={20}
        slidesPerView={1}
        className="tourSlider"
      >
        {overview.images.map((img, index) => (
          <SwiperSlide key={index}>
            <img src={img} alt={`${title} ${index}`} className="tourImg" />
          </SwiperSlide>
        ))}
      </Swiper>
    )}
  </section>
)}


        {/* ===== Highlights ===== */}
        {highlights && (
          <section className="tourSection tourHighlights">
            <h2>🌊 Highlights</h2>
            <ul>
              {highlights.map((item, idx) => <li key={idx}>{item}</li>)}
            </ul>
          </section>
        )}

        {/* ===== Location ===== */}
        {location && (
          <section className="tourSection">
            <h2>📍 Location</h2>
            <ul>
              {location.map((item, idx) => <li key={idx}>{item}</li>)}
            </ul>
          </section>
        )}

        {/* ===== How to Reach ===== */}
        {howToReach && (
          <section className="tourSection">
            <h2>🚤 How to Reach</h2>
            <ol>
              {howToReach.map((item, idx) => (
                <li key={idx}>
                  <strong>{item.from}:</strong>
                  <ul>
                    {item.details.map((detail, dIdx) => <li key={dIdx}>{detail}</li>)}
                  </ul>
                </li>
              ))}
            </ol>
          </section>
        )}

        {/* ===== Things to Do ===== */}
        {thingsToDo && (
          <section className="tourSection tourThings">
            <h2>🪸 Things to Do</h2>
            <ul>
              {thingsToDo.list.map((item, idx) => <li key={idx}>{item}</li>)}
            </ul>
            {thingsToDo.image && <img src={thingsToDo.image} alt={title} className="tourImg" />}
          </section>
        )}

        {/* ===== Facilities ===== */}
        {facilities && (
          <section className="tourSection">
            <h2>🏞️ Facilities</h2>
            <ul>
              {facilities.map((item, idx) => <li key={idx}>{item}</li>)}
            </ul>
          </section>
        )}

        {/* ===== Best Time ===== */}
        {bestTime && (
          <section className="tourSection">
            <h2>🌤️ Best Time to Visit</h2>
            <ul>
              {bestTime.map((item, idx) => <li key={idx}>{item}</li>)}
            </ul>
          </section>
        )}

        {/* ===== Travel Tips ===== */}
        {travelTips && (
          <section className="tourSection">
            <h2>⚓ Travel Tips</h2>
            <ul>
              {travelTips.map((item, idx) => <li key={idx}>{item}</li>)}
            </ul>
          </section>
        )}
      </div>
    </div>
  );
};

export default TourPage;
